import { errorNotifier } from "../../..";
import http, { AUTH_ROUTES } from "../../../service/api";

export const laravelHost = "http://localhost:8000";
export const addMessage = `${laravelHost}/api/addMessage` //local server
export const sendChatMessage = "https://f8.codester.dev/api/chats/messages" //f8
export const getChatMessages = (recipient_id) => `https://f8.codester.dev/api/chats/messages?recipient_id=${recipient_id}` //f8 

export const getInteractingUsers = `${laravelHost}/api/getInteractingUsers`
export const getChatInteractingUsers = "https://f8.codester.dev/api/chats" //f8
export const getMessages = `${laravelHost}/api/getMessages`
export const allContactsRoute = `${laravelHost}/api/contacts`
//export const socketHost = "https://chat.pindogo.com/";
//export const socketHost = "http://164.92.100.121:8080/";
//export const socketHost = "https://seashell-app-upewk.ondigitalocean.app:8080";
//export const socketHost = "http://chat.pindogo.com"
export const socketHost = "https://shark-app-rgk5s.ondigitalocean.app"

export const getChatContacts = async (setLoading) => {
  try {
    const res = await http.get(AUTH_ROUTES.GET_ALL_CHAT_CONTACTS(setLoading));
    setLoading(false);
    return res;
  } catch (e) {
    setLoading(false);
  }
};



export const getGroup = async (setGroup, acct_type, id, setLoading) => {
  try {
    const data = await http.get(AUTH_ROUTES.GET_GROUP(acct_type, id));
    setGroup(data?.data?.data);
    setLoading(false);
  } catch (e) {
    setLoading(false);
  }
};

export const getChats = async (setChats, acct_type, setLoading) => {
  try {
    const data = await http.get(AUTH_ROUTES.GET_ALL_CHATS(acct_type));
    setChats(data?.data?.data);
    setLoading(false);
  } catch (e) {
    setLoading(false);
  }
};

export const sendMessage = async (payload, acct_type, setLoading) => {
  try {
    await http.post(AUTH_ROUTES.SEND_MESSAGE(acct_type), payload);
    setLoading(false);
  } catch (e) {
    setLoading(false);
    errorNotifier(e.response?.data?.data?.message);
  }
};
